
import {useState} from 'react';
import cn from 'classnames';
import {Icon} from '@burna/monster-design-system';
import img1 from 'assets/help/1.png';
import img2 from 'assets/help/2.png';
import img3 from 'assets/help/3.png';
import img4 from 'assets/help/4.jpg';
import img5 from 'assets/help/5.jpg';
import img6 from 'assets/help/6.png';
import styles from './index.module.scss';


const Help = () => {
  const [open, setOpen] = useState([true, true]);
  const toggleOpen = i => () => setOpen(open.map((v, j) => j === i ? !v : v));
  const forceOpen = i => () => setOpen(open.map((v, j) => j === i ? true : v));

  return (
    <div className={styles.wrapper}>
      <ul className={styles.legend}>
        <li
          className={cn({
            [styles.legendSection]: true,
            [styles.legendSectionOpen]: open[0],
          })}
        >
          <div className={styles.legendArrow} onClick={toggleOpen(0)}>
            <Icon className={styles.legendArrowIcon} type="chevron-down" />
          </div>
          <a href="#what-is-zDrive" onClick={forceOpen(0)}>What is zDrive?</a>
          <ul>
            <li className={styles.legendItem}><a href="#zDrive-Common-use-cases">zDrive Common use cases</a></li>
          </ul>
        </li>
        <li
          className={cn({
            [styles.legendSection]: true,
            [styles.legendSectionOpen]: open[1],
          })}
        >
          <div className={styles.legendArrow} onClick={toggleOpen(1)}>
            <Icon className={styles.legendArrowIcon} type="chevron-down" />
          </div>
          <a href="#how-to-use-zDrive" onClick={forceOpen(1)}>How to use zDrive?</a>
          <ul>
            <li className={styles.legendItem}><a href="#upload">Upload</a></li>
            <li className={styles.legendItem}><a href="#share-file-setting">Share/File setting</a></li>
            <li className={styles.legendItem}><a href="#download-scan">Download/Scan</a></li>
            <li className={styles.legendItem}><a href="#file-manager">File Manager</a></li>
            <li className={styles.legendItem}><a href="#contact-us">Contact us</a></li>
          </ul>
        </li>
      </ul>
      <h1 id="what-is-zDrive" className={styles.heading}><a href="#what-is-zDrive">What is zDrive?</a></h1>
      <p className={styles.p}>
        zDrive is a safe and easy-to-use file-sharing platform. You can upload, organize, scan, share, and download files from any device. There are no registration fees, and you get full access to zDrive's features once you sign in. Even if you're not registered, you can still upload and share files up to 20 megabytes in size. Also there is a multi-AV behind zDrive and you can scan your files before downloading. You can upload as many files as you want and you can download them as many times as you need.
      </p>
      <h2 id="zDrive-Common-use-cases" className={styles.heading}><a href="#zDrive-Common-use-cases">zDrive Common use cases</a></h2>
      <p className={styles.p}>
        zDrive can be used in a variety of scenarios.
      </p>
      <ul className={styles.ul}>
        <li>Personal File Storage and Backup</li>
        <li>Collaboration and File Sharing</li>
        <li>Remote Work and Accessibility</li>
        <li>Data Security and Compliance</li>
        <li>Media Library Management</li>
        <li>Upload center for media providers</li>
        <li>And many more use cases which need a cloud storage secured by anti viruses</li>
      </ul>
      <h1 id="how-to-use-zDrive" className={styles.heading}><a href="#how-to-use-zDrive">How to use zDrive?</a></h1>
      <p className={styles.p}>
        Here is the instructions for using zDrive:
      </p>
      <h2 id="upload" className={styles.heading}><a href="#upload">Upload:</a></h2>
      <p className={styles.p}>
        You can upload your files either by dragging them on the box or clicking on the selected area and choosing your file. You can also paste a link in the text box and zDrive will download the file and store it in your space.
        <img className={styles.img} src={img1} />
      </p>
      <h2 id="share-file-setting" className={styles.heading}><a href="#share-file-setting">Share/File setting:</a></h2>
      <p className={styles.p}>
        After uploading your files, you can share the download link, scan your file or create password protected or temporary links.        <img className={styles.img} />
        <img className={styles.img} src={img2} />
      </p>
      <h2 id="download-scan" className={styles.heading}><a href="#download-scan">Download/Scan:</a></h2>
      <p className={styles.p}>
        After uploading your files, you can share the download link, scan your file or create password protected or temporary links.
        <img className={styles.img} src={img3} />
      </p>
      <h2 id="file-manager" className={styles.heading}><a href="#file-manager">File Manager:</a></h2>
      <p className={styles.p}>
        You can access the file manager by clicking on your profile and going to the Manage section. Here you can see your files, remove them, upload new files, download them directly (without any scans) or access the file settings and scan and share them.
        <img className={styles.img} src={img4} />
      </p>
      <h2 id="contact-us" className={styles.heading}><a href="#contact-us">Contact us:</a></h2>
      <p className={styles.p}>
        If you have any further questions you can contact us by clicking the chat Icon and we will answer you shortly. Remember, zDrive is free once you sign up and you can enjoy using this service as much as you want.
        <img className={styles.img} src={img5} />
        <img className={styles.img} src={img6} />
      </p>
    </div>
  );
};

export default Help;
